import React, { SyntheticEvent } from "react";
import { Dropdown } from "@cmsgov/ds-medicare-gov";
import {
  addNewRelicPageAction,
  useTranslate,
  sendTealiumEvent,
} from "../../../helpers";
import { CCXPDropdown } from "../../../components";

interface Props {
  value: string;
  options: { label: string; value: string }[];
  onFilterUpdate: (carrier: string) => void;
  basicMode?: boolean;
}

const CarrierFilter: React.FunctionComponent<Props> = ({
  options,
  value,
  onFilterUpdate,
  basicMode,
}) => {
  const t = useTranslate();

  const updateFilters = (newValue: string): void => {
    addNewRelicPageAction("Search Results Filter", {
      filter: "Carrier Preference",
      value: newValue !== "" ? newValue : "Not Selected",
    });
    sendTealiumEvent(
      "Find Plans - Available Plans",
      "Insurance Carrier Pull down"
    );
    onFilterUpdate(newValue);
  };

  const label = t("plan_terms.insurance_carrier");

  return basicMode ? (
    <Dropdown
      onChange={({
        currentTarget: { value },
      }: SyntheticEvent<HTMLSelectElement>): void => {
        updateFilters(value as string);
      }}
      name="preferred-insurance-carrier"
      value={value}
      label={label}
      id="preferred-insurance-carrier"
      options={[
        {
          label: t("app.terms.select_preferred_insurance_carrier"),
          value: "",
        },
        ...options,
      ]}
    />
  ) : (
    <div className="Filter">
      <CCXPDropdown
        label={label}
        size="widest"
        options={options}
        value={value}
        onUpdate={updateFilters}
        keepDefaultLabel
      />
    </div>
  );
};

export default CarrierFilter;
